import { useContext } from 'react'

import type { IVideoContext } from './VideoProvider'
import { VideoContext } from './VideoProvider'

/**
 * Hook to access the VideoContext.
 * Must be used within a VideoProvider.
 */
export default function useVideoContext(): IVideoContext {
	const context = useContext(VideoContext)
	if (!context) {
		throw new Error('useVideoContext must be used within a VideoProvider')
	}
	return context
}
